import * as types from '../../action/actionTypes';
import initialState from '../initialState';

export default function InstallationReducer(state = initialState.Administartion, action) {
    switch (action.type) {
        case types.GET_DISCOVERY_LIST: return {
           ...state, Installations: action.getResponse,
        };
        case types.GET_BUILDINGS_DISCOVERED_LIST: return {
            ...state, BuildingsDiscovered: action.getResponse,
         };
         case types.ADD_NEW_BUILDINGS: return {
            ...state, AddNewBuildings: action.getResponse,
         };
        case types.GET_SERVER_ID: return {
            ...state,ServerId: action.getResponse,
        };
        case types.GET_LICENSE_INFORMATION: return {
            ...state,License: action.getResponse,
        };
        case types.GET_LICENSED_CUSTOMER_INFORMATION: return {
            ...state,CustomerInformation: action.getResponse,
        };
        case types.GET_FEATURE_LICENSE_INFORMATION: return {
            ...state,FeatureLicenseInformation: action.getResponse,
        };
        case types.GET_USER_ROLE: return {
            ...state,UserRoles: action.getResponse,
        };
        case types.GET_USER_LIST: return {
            ...state,UserLists: action.getResponse,
        };
        case types.GET_USER_DETAILS: return {
            ...state,UserDeatils: action.getResponse,
        };
        case types.GET_TRANEUSER_DETAILS: return {
            ...state,TraneUserDeatils: action.getResponse,
        };
        case types.SET_USER_DETAILS: return {
            ...state, ClientSideUserData: action.Data,
        };
        case types.CLEAR_USER_DETAILS: return {
            ...state, ClientSideUserData: [],
        };
        case types.GET_IS_USERNAME_EXISTS: return {
            ...state, IsUserNameExists : action.getResponse
         };
         case types.UPLOAD_STATUS: return {
            ...state, UploadStatus : action.getResponse
         };
         case types.UPLOAD_LICENSE_FILE_RESPONSE: return {
            ...state, UploadLicenseFileResponse : action.getResponse
         };
         case types.GET_USERCHANGELOGS_SUCCESSFULL: return {
            ...state, UserChangeLogs : action.getResponse.data
         };
         case types.GET_APPLICATION_VERSION: return {
            ...state,ApplicationVersion: action.getResponse,
        };
         case types.BUILDING_SYNCHRONIZATION: return {
            ...state,Synchronizedata: action.getResponse,
         };
         case types.GET_TRANE_USER: return {
            ...state, Traneuser: action.getResponse,
         };
         case types.GET_TRANE_SITES: return {
            ...state, TraneSites: action.getResponse,
         };
         case types.TRANE_CONNECT_ERROR_STATUS: return {
             ...state, TraneConnectStatus: action.getResponse.data,
         };
         case types.GET_PRODUCT_FULLVERSION: return {
             ...state, Productfullversion: action.getResponse,
         };
         case types.GET_DB_VERSION: return {
             ...state, Dbversion: action.getResponse,
         };
         case types.GET_BUILDINGS_LIST: return {
             ...state, BuildingList: action.getResponse,
         };
         case types.GET_TENANT_WORKORDER_LICENSE: return {
             ...state, TenantWorkOrderLicense: action.getResponse,
         }
         case types.GET_BUILDINGS_TIMEZONES_SUCCESSFULL: return {
             ...state, BuildingsTimeZones: action.getResponse
         }
         case types.SET_RESET_PASSWORD_ERROR: return {
            ...state, ResetPasswordErrorMsg: action.getResponse
         }
         case types.GET_INSTANCETYPE:  return {
            ...state, IsCloud: action.getResponse
         }
         case types.GET_DEVICE_PANEL_DETAILS: return{
            ...state, DevicePanelDetails: action.getResponse
         }
        default : return state; 
    }   
}